// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'megaphone-solid';

export const Component = () => (
  <path d='M23.558 3.479v16.666c0 .335-.144.48-.48.48-.334 0-.478-.145-.478-.48v-.622l-3.927-.48V4.629l3.927-.526V3.48c0-.335.144-.479.479-.479.335 0 .479.144.479.479ZM2.293 6.736l15.373-2.012v14.177l-4.885-.623v2.874c0 .335-.144.478-.479.478h-.143l-4.886-1.005a.466.466 0 0 1-.382-.479v-2.634l-4.598-.623a1.49 1.49 0 0 1-.91-.526 1.31 1.31 0 0 1-.383-.91V8.22c0-.383.144-.718.383-1.005a1.69 1.69 0 0 1 .91-.48Zm5.555 10.872v2.155l3.928.767v-2.395l-3.928-.526v-.001Z' />
);

export const viewBox = '0 0 25 25';
